module.exports = __webpack_public_path__ + "static/media/image-card-2.5eea72b4.png";